import { Icon } from '../../UI';
import { DropdownMenu } from './Dropdown-menu';
import { NestedMenuModel } from './dropdown-menu-props.model';

const NestedMenu: React.FC<
  NestedMenuModel & { dropdownTooltipClassName: string }
> = ({
  dropdownItems,
  dropdownItemsData,
  item,
  dropdownTooltipClassName,
  handleClick,
  hideItemOnClick,
  tooltipChildren = { element: null, placement: 'top' },
}) => {
  return (
    <DropdownMenu
      dropdownItems={dropdownItems || []}
      dropdownTooltipClassName={`${dropdownTooltipClassName} z-20`}
      dropdownItemsData={dropdownItemsData}
      dropdownTooltipYOffset={20}
      placement="left-start"
      handleClick={handleClick}
      tooltipChildren={tooltipChildren}
      hideOnItemClick={hideItemOnClick}
      isNested
    >
      <div className="flex items-center justify-between w-full gap-2">
        <span>{item}</span>
        <Icon
          svgName="dropdownArrow"
          className={'dark:group-hover:text-black'}
        />
      </div>
    </DropdownMenu>
  );
};

export default NestedMenu;
